(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(15133);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 15133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
;// CONCATENATED MODULE: ./src/landingPage/views/HomePage/HomePage.jsx
/* Homepage imports commented out - content is hidden
import { useState, useEffect } from "react";
import { InfoBox } from "../components/form/InfoBox";
import styles from "./HomePage.module.less";
import { Hero, HeroCol, HeroTitle, HeroSubtitle } from "../../components/Hero";
import {
  Section,
  SectionCol,
  SectionHeading,
  SectionParagraph,
  SectionImage,
  SectionBigNumber,
} from "../../components/Section";
import { LinkButton } from "../../components/Button";
import { Customers } from "../../components/subcomponents/Customers";
import { BottomCta } from "../../components/subcomponents/BottomCta";
import { SecurityBadges } from "../../components/subcomponents/SecurityBadges";
import { linksConstants } from "../../../constants/linksConstants";

import PlatformTop from "./assets/PlatformTop.svg";
import { sendGaEvent } from "../../../config/userTracking";
import ServingEnterprisesSvg from "./ServingEnterprisesSvg";
import LessCostSvg from "./LessCostSvg";
import SavedPerDeploymentSvg from "./SavedPerDeploymentSvg";
import { LocationMapHomePage } from "../About/components/LocationMapHomePage";
*/ var HomePage = function() {
    // Homepage content hidden - only footer and cookies message should display
    return null;
/* Original HomePage content commented out below
  const [attentionBox, setAttentionBox] = useState(false);

  useEffect(() => {
    if (window.location.state) {
      const isInfoboxPresent = window.location.state.infobox;
      if (isInfoboxPresent) setAttentionBox(true);
    }
  }, []);
  const sendCtaGaEvent = () => {
    sendGaEvent({
      action: `CTA Click - Request A Demo`,
      category: "Main CTA",
      label: `/app/contact`,
    });
  };

  return (
    <>
      {attentionBox && <InfoBox closeModal={() => setAttentionBox(false)} type="Attention" />}
      <Hero background="violet-900" className={styles.Hero} withStarsAnimation>
        <HeroCol>
          <HeroTitle multiLine>Your External Data Partner</HeroTitle>
          <HeroSubtitle className={styles.ExternalDataPartner}>
            Let us manage your trusted data workflows so you can focus on value from use cases.
          </HeroSubtitle>
          <div id="svg-blocks" style={{ marginBottom: "35px", width: "100%" }}>
            <svg
              width="322"
              height="43"
              viewBox="0 0 322 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_186_290)">
                <rect x="6" y="4" width="81" height="31" rx="5" stroke="#7F7AD0" strokeWidth="2" />
              </g>
              <path
                d="M26.0127 18.9072C26.0127 20.0329 25.7962 20.974 25.3633 21.7305C24.9349 22.4824 24.3128 23.0498 23.4971 23.4326C22.6813 23.8109 21.6992 24 20.5508 24H17.7207V14.0059H20.8584C21.9066 14.0059 22.8158 14.1927 23.5859 14.5664C24.3561 14.9355 24.9531 15.4847 25.377 16.2139C25.8008 16.9385 26.0127 17.8363 26.0127 18.9072ZM23.8115 18.9619C23.8115 18.2236 23.7021 17.6175 23.4834 17.1436C23.2692 16.665 22.9502 16.3118 22.5264 16.084C22.1071 15.8561 21.5876 15.7422 20.9678 15.7422H19.8398V22.25H20.749C21.7835 22.25 22.5514 21.9743 23.0527 21.4229C23.5586 20.8714 23.8115 20.0511 23.8115 18.9619ZM30.0049 16.3574V24H27.9199V16.3574H30.0049ZM28.9658 13.3633C29.2757 13.3633 29.5423 13.4362 29.7656 13.582C29.9889 13.7233 30.1006 13.9899 30.1006 14.3818C30.1006 14.7692 29.9889 15.0381 29.7656 15.1885C29.5423 15.3343 29.2757 15.4072 28.9658 15.4072C28.6514 15.4072 28.3825 15.3343 28.1592 15.1885C27.9404 15.0381 27.8311 14.7692 27.8311 14.3818C27.8311 13.9899 27.9404 13.7233 28.1592 13.582C28.3825 13.4362 28.6514 13.3633 28.9658 13.3633ZM37.5312 21.7305C37.5312 22.25 37.4082 22.6898 37.1621 23.0498C36.9206 23.4053 36.5583 23.6764 36.0752 23.8633C35.5921 24.0456 34.9906 24.1367 34.2705 24.1367C33.7373 24.1367 33.2793 24.1025 32.8965 24.0342C32.5182 23.9658 32.1354 23.8519 31.748 23.6924V21.9697C32.1628 22.1566 32.6071 22.3115 33.0811 22.4346C33.5596 22.5531 33.9788 22.6123 34.3389 22.6123C34.7445 22.6123 35.0339 22.5531 35.207 22.4346C35.3848 22.3115 35.4736 22.152 35.4736 21.9561C35.4736 21.8285 35.4372 21.7145 35.3643 21.6143C35.2959 21.5094 35.1455 21.3932 34.9131 21.2656C34.6807 21.1335 34.3161 20.9626 33.8193 20.7529C33.3408 20.5524 32.9466 20.3496 32.6367 20.1445C32.3314 19.9395 32.1035 19.6979 31.9531 19.4199C31.8073 19.1374 31.7344 18.7796 31.7344 18.3467C31.7344 17.6403 32.0078 17.1094 32.5547 16.7539C33.1061 16.3939 33.8421 16.2139 34.7627 16.2139C35.2367 16.2139 35.6878 16.2617 36.1162 16.3574C36.5492 16.4531 36.9935 16.6058 37.4492 16.8154L36.8203 18.3193C36.4421 18.1553 36.0843 18.0208 35.7471 17.916C35.4144 17.8112 35.0749 17.7588 34.7285 17.7588C34.4232 17.7588 34.193 17.7998 34.0381 17.8818C33.8831 17.9639 33.8057 18.0892 33.8057 18.2578C33.8057 18.3809 33.8444 18.4902 33.9219 18.5859C34.0039 18.6816 34.1589 18.7887 34.3867 18.9072C34.6191 19.0212 34.9587 19.1693 35.4053 19.3516C35.8382 19.5293 36.2142 19.7161 36.5332 19.9121C36.8522 20.1035 37.0983 20.3428 37.2715 20.6299C37.4447 20.9124 37.5312 21.2793 37.5312 21.7305ZM42.2617 24.1367C41.5052 24.1367 40.8604 24 40.3271 23.7266C39.7939 23.4486 39.3883 23.0202 39.1104 22.4414C38.8324 21.8626 38.6934 21.1221 38.6934 20.2197C38.6934 19.2855 38.8506 18.5244 39.165 17.9365C39.484 17.3441 39.9238 16.9089 40.4844 16.6309C41.0495 16.3529 41.7035 16.2139 42.4463 16.2139C42.9749 16.2139 43.4307 16.2663 43.8135 16.3711C44.2008 16.4714 44.5381 16.5921 44.8252 16.7334L44.21 18.3467C43.8818 18.2145 43.5765 18.1074 43.2939 18.0254C43.0114 17.9388 42.7288 17.8955 42.4463 17.8955C42.0817 17.8955 41.7786 17.9821 41.5371 18.1553C41.2956 18.3239 41.1156 18.5791 40.9971 18.9209C40.8786 19.2627 40.8193 19.6911 40.8193 20.2061C40.8193 20.7119 40.8831 21.1312 41.0107 21.4639C41.1383 21.7965 41.3229 22.0449 41.5645 22.209C41.806 22.3685 42.0999 22.4482 42.4463 22.4482C42.8792 22.4482 43.2643 22.3913 43.6016 22.2773C43.9388 22.1589 44.2669 21.9948 44.5859 21.7852V23.5693C44.2669 23.7699 43.932 23.9134 43.5811 24C43.2347 24.0911 42.7949 24.1367 42.2617 24.1367ZM53.3086 20.165C53.3086 20.8031 53.222 21.3682 53.0488 21.8604C52.8802 22.3525 52.6318 22.7695 52.3037 23.1113C51.9801 23.4486 51.5882 23.7038 51.1279 23.877C50.6722 24.0501 50.1572 24.1367 49.583 24.1367C49.0452 24.1367 48.5508 24.0501 48.0996 23.877C47.653 23.7038 47.2633 23.4486 46.9307 23.1113C46.6025 22.7695 46.3473 22.3525 46.165 21.8604C45.9873 21.3682 45.8984 20.8031 45.8984 20.165C45.8984 19.3174 46.0488 18.5996 46.3496 18.0117C46.6504 17.4238 47.0788 16.9772 47.6348 16.6719C48.1908 16.3665 48.8538 16.2139 49.624 16.2139C50.3395 16.2139 50.973 16.3665 51.5244 16.6719C52.0804 16.9772 52.5156 17.4238 52.8301 18.0117C53.1491 18.5996 53.3086 19.3174 53.3086 20.165ZM48.0244 20.165C48.0244 20.6663 48.0791 21.0879 48.1885 21.4297C48.2979 21.7715 48.4688 22.029 48.7012 22.2021C48.9336 22.3753 49.2367 22.4619 49.6104 22.4619C49.9795 22.4619 50.278 22.3753 50.5059 22.2021C50.7383 22.029 50.9069 21.7715 51.0117 21.4297C51.1211 21.0879 51.1758 20.6663 51.1758 20.165C51.1758 19.6592 51.1211 19.2399 51.0117 18.9072C50.9069 18.57 50.7383 18.3171 50.5059 18.1484C50.2734 17.9798 49.9704 17.8955 49.5967 17.8955C49.0452 17.8955 48.6442 18.0846 48.3936 18.4629C48.1475 18.8411 48.0244 19.4085 48.0244 20.165ZM56.8496 24L53.9375 16.3574H56.1182L57.5947 20.7119C57.6768 20.9671 57.7406 21.236 57.7861 21.5186C57.8363 21.8011 57.8704 22.054 57.8887 22.2773H57.9434C57.957 22.0358 57.9889 21.7783 58.0391 21.5049C58.0938 21.2314 58.1644 20.9671 58.251 20.7119L59.7207 16.3574H61.9014L58.9893 24H56.8496ZM66.1533 16.2139C66.8597 16.2139 67.4681 16.3506 67.9785 16.624C68.4889 16.8929 68.8831 17.2848 69.1611 17.7998C69.4391 18.3148 69.5781 18.9437 69.5781 19.6865V20.6982H64.6494C64.6722 21.2861 64.8477 21.7487 65.1758 22.0859C65.5085 22.4186 65.9688 22.585 66.5566 22.585C67.0443 22.585 67.4909 22.5348 67.8965 22.4346C68.3021 22.3343 68.7191 22.1839 69.1475 21.9834V23.5967C68.7692 23.7835 68.3727 23.9202 67.958 24.0068C67.5479 24.0934 67.0488 24.1367 66.4609 24.1367C65.6953 24.1367 65.0163 23.9954 64.4238 23.7129C63.8359 23.4303 63.3734 22.9997 63.0361 22.4209C62.7035 21.8421 62.5371 21.113 62.5371 20.2334C62.5371 19.3402 62.6875 18.5973 62.9883 18.0049C63.2936 17.4079 63.7174 16.9613 64.2598 16.665C64.8021 16.3643 65.4333 16.2139 66.1533 16.2139ZM66.167 17.6973C65.7614 17.6973 65.4242 17.8271 65.1553 18.0869C64.891 18.3467 64.7383 18.7546 64.6973 19.3105H67.623C67.6185 19.0007 67.5615 18.7249 67.4521 18.4834C67.3473 18.2419 67.1878 18.0505 66.9736 17.9092C66.764 17.7679 66.4951 17.6973 66.167 17.6973ZM75.5391 16.2139C75.6439 16.2139 75.7646 16.2207 75.9014 16.2344C76.0426 16.2435 76.1566 16.2572 76.2432 16.2754L76.0859 18.2305C76.0176 18.2077 75.9196 18.1917 75.792 18.1826C75.6689 18.1689 75.5618 18.1621 75.4707 18.1621C75.2018 18.1621 74.9398 18.1963 74.6846 18.2646C74.4339 18.333 74.2083 18.4447 74.0078 18.5996C73.8073 18.75 73.6478 18.9505 73.5293 19.2012C73.4154 19.4473 73.3584 19.7503 73.3584 20.1104V24H71.2734V16.3574H72.8525L73.1602 17.6426H73.2627C73.4131 17.3828 73.5999 17.1458 73.8232 16.9316C74.0511 16.7129 74.3086 16.5397 74.5957 16.4121C74.8874 16.2799 75.2018 16.2139 75.5391 16.2139Z"
                fill="#7F7AD0"
              />
              <g filter="url(#filter1_d_186_290)">
                <rect
                  x="120"
                  y="4"
                  width="81"
                  height="31"
                  rx="5"
                  stroke="#7F7AD0"
                  strokeWidth="2"
                />
              </g>
              <path
                d="M141.708 18.9072C141.708 20.0329 141.492 20.974 141.059 21.7305C140.63 22.4824 140.008 23.0498 139.192 23.4326C138.377 23.8109 137.395 24 136.246 24H133.416V14.0059H136.554C137.602 14.0059 138.511 14.1927 139.281 14.5664C140.051 14.9355 140.648 15.4847 141.072 16.2139C141.496 16.9385 141.708 17.8363 141.708 18.9072ZM139.507 18.9619C139.507 18.2236 139.397 17.6175 139.179 17.1436C138.965 16.665 138.646 16.3118 138.222 16.084C137.802 15.8561 137.283 15.7422 136.663 15.7422H135.535V22.25H136.444C137.479 22.25 138.247 21.9743 138.748 21.4229C139.254 20.8714 139.507 20.0511 139.507 18.9619ZM146.767 16.2139C147.473 16.2139 148.081 16.3506 148.592 16.624C149.102 16.8929 149.496 17.2848 149.774 17.7998C150.052 18.3148 150.191 18.9437 150.191 19.6865V20.6982H145.263C145.285 21.2861 145.461 21.7487 145.789 22.0859C146.122 22.4186 146.582 22.585 147.17 22.585C147.658 22.585 148.104 22.5348 148.51 22.4346C148.915 22.3343 149.332 22.1839 149.761 21.9834V23.5967C149.382 23.7835 148.986 23.9202 148.571 24.0068C148.161 24.0934 147.662 24.1367 147.074 24.1367C146.309 24.1367 145.63 23.9954 145.037 23.7129C144.449 23.4303 143.987 22.9997 143.649 22.4209C143.317 21.8421 143.15 21.113 143.15 20.2334C143.15 19.3402 143.301 18.5973 143.602 18.0049C143.907 17.4079 144.331 16.9613 144.873 16.665C145.415 16.3643 146.047 16.2139 146.767 16.2139ZM146.78 17.6973C146.375 17.6973 146.037 17.8271 145.769 18.0869C145.504 18.3467 145.352 18.7546 145.311 19.3105H148.236C148.232 19.0007 148.175 18.7249 148.065 18.4834C147.961 18.2419 147.801 18.0505 147.587 17.9092C147.377 17.7679 147.108 17.6973 146.78 17.6973ZM153.705 24L150.793 16.3574H152.974L154.45 20.7119C154.532 20.9671 154.596 21.236 154.642 21.5186C154.692 21.8011 154.726 22.054 154.744 22.2773H154.799C154.812 22.0358 154.844 21.7783 154.895 21.5049C154.949 21.2314 155.02 20.9671 155.106 20.7119L156.576 16.3574H158.757L155.845 24H153.705ZM163.009 16.2139C163.715 16.2139 164.324 16.3506 164.834 16.624C165.344 16.8929 165.739 17.2848 166.017 17.7998C166.295 18.3148 166.434 18.9437 166.434 19.6865V20.6982H161.505C161.528 21.2861 161.703 21.7487 162.031 22.0859C162.364 22.4186 162.824 22.585 163.412 22.585C163.9 22.585 164.346 22.5348 164.752 22.4346C165.158 22.3343 165.575 22.1839 166.003 21.9834V23.5967C165.625 23.7835 165.228 23.9202 164.813 24.0068C164.403 24.0934 163.904 24.1367 163.316 24.1367C162.551 24.1367 161.872 23.9954 161.279 23.7129C160.691 23.4303 160.229 22.9997 159.892 22.4209C159.559 21.8421 159.393 21.113 159.393 20.2334C159.393 19.3402 159.543 18.5973 159.844 18.0049C160.149 17.4079 160.573 16.9613 161.115 16.665C161.658 16.3643 162.289 16.2139 163.009 16.2139ZM163.022 17.6973C162.617 17.6973 162.28 17.8271 162.011 18.0869C161.746 18.3467 161.594 18.7546 161.553 19.3105H164.479C164.474 19.0007 164.417 18.7249 164.308 18.4834C164.203 18.2419 164.043 18.0505 163.829 17.9092C163.619 17.7679 163.351 17.6973 163.022 17.6973ZM170.214 24H168.129V13.3633H170.214V24ZM179.354 20.165C179.354 20.8031 179.267 21.3682 179.094 21.8604C178.925 22.3525 178.677 22.7695 178.349 23.1113C178.025 23.4486 177.633 23.7038 177.173 23.877C176.717 24.0501 176.202 24.1367 175.628 24.1367C175.09 24.1367 174.596 24.0501 174.145 23.877C173.698 23.7038 173.308 23.4486 172.976 23.1113C172.647 22.7695 172.392 22.3525 172.21 21.8604C172.032 21.3682 171.943 20.8031 171.943 20.165C171.943 19.3174 172.094 18.5996 172.395 18.0117C172.695 17.4238 173.124 16.9772 173.68 16.6719C174.236 16.3665 174.899 16.2139 175.669 16.2139C176.384 16.2139 177.018 16.3665 177.569 16.6719C178.125 16.9772 178.561 17.4238 178.875 18.0117C179.194 18.5996 179.354 19.3174 179.354 20.165ZM174.069 20.165C174.069 20.6663 174.124 21.0879 174.233 21.4297C174.343 21.7715 174.514 22.029 174.746 22.2021C174.979 22.3753 175.282 22.4619 175.655 22.4619C176.024 22.4619 176.323 22.3753 176.551 22.2021C176.783 22.029 176.952 21.7715 177.057 21.4297C177.166 21.0879 177.221 20.6663 177.221 20.165C177.221 19.6592 177.166 19.2399 177.057 18.9072C176.952 18.57 176.783 18.3171 176.551 18.1484C176.318 17.9798 176.015 17.8955 175.642 17.8955C175.09 17.8955 174.689 18.0846 174.438 18.4629C174.192 18.8411 174.069 19.4085 174.069 20.165ZM185.328 16.2139C186.189 16.2139 186.884 16.5488 187.413 17.2188C187.946 17.8887 188.213 18.8708 188.213 20.165C188.213 21.0309 188.088 21.7601 187.837 22.3525C187.586 22.9404 187.24 23.3848 186.798 23.6855C186.356 23.9863 185.848 24.1367 185.273 24.1367C184.904 24.1367 184.588 24.0911 184.323 24C184.059 23.9043 183.833 23.7835 183.646 23.6377C183.46 23.4873 183.298 23.3278 183.161 23.1592H183.052C183.088 23.3415 183.116 23.5283 183.134 23.7197C183.152 23.9111 183.161 24.098 183.161 24.2803V27.3633H181.076V16.3574H182.771L183.065 17.3486H183.161C183.298 17.1436 183.464 16.9544 183.66 16.7812C183.856 16.6081 184.091 16.4714 184.364 16.3711C184.642 16.2663 184.964 16.2139 185.328 16.2139ZM184.658 17.8818C184.294 17.8818 184.004 17.957 183.79 18.1074C183.576 18.2578 183.419 18.4834 183.318 18.7842C183.223 19.085 183.17 19.4655 183.161 19.9258V20.1514C183.161 20.6436 183.207 21.0605 183.298 21.4023C183.394 21.7441 183.551 22.0039 183.77 22.1816C183.993 22.3594 184.298 22.4482 184.686 22.4482C185.005 22.4482 185.267 22.3594 185.472 22.1816C185.677 22.0039 185.829 21.7441 185.93 21.4023C186.035 21.056 186.087 20.6344 186.087 20.1377C186.087 19.3903 185.971 18.8275 185.738 18.4492C185.506 18.071 185.146 17.8818 184.658 17.8818Z"
                fill="#7F7AD0"
              />
              <g filter="url(#filter2_d_186_290)">
                <rect
                  x="235"
                  y="4"
                  width="81"
                  height="31"
                  rx="5"
                  stroke="#7F7AD0"
                  strokeWidth="2"
                />
              </g>
              <path
                d="M260.844 18.9072C260.844 20.0329 260.627 20.974 260.194 21.7305C259.766 22.4824 259.144 23.0498 258.328 23.4326C257.512 23.8109 256.53 24 255.382 24H252.552V14.0059H255.689C256.738 14.0059 257.647 14.1927 258.417 14.5664C259.187 14.9355 259.784 15.4847 260.208 16.2139C260.632 16.9385 260.844 17.8363 260.844 18.9072ZM258.643 18.9619C258.643 18.2236 258.533 17.6175 258.314 17.1436C258.1 16.665 257.781 16.3118 257.357 16.084C256.938 15.8561 256.419 15.7422 255.799 15.7422H254.671V22.25H255.58C256.615 22.25 257.382 21.9743 257.884 21.4229C258.39 20.8714 258.643 20.0511 258.643 18.9619ZM265.902 16.2139C266.609 16.2139 267.217 16.3506 267.728 16.624C268.238 16.8929 268.632 17.2848 268.91 17.7998C269.188 18.3148 269.327 18.9437 269.327 19.6865V20.6982H264.398C264.421 21.2861 264.597 21.7487 264.925 22.0859C265.257 22.4186 265.718 22.585 266.306 22.585C266.793 22.585 267.24 22.5348 267.646 22.4346C268.051 22.3343 268.468 22.1839 268.896 21.9834V23.5967C268.518 23.7835 268.122 23.9202 267.707 24.0068C267.297 24.0934 266.798 24.1367 266.21 24.1367C265.444 24.1367 264.765 23.9954 264.173 23.7129C263.585 23.4303 263.122 22.9997 262.785 22.4209C262.452 21.8421 262.286 21.113 262.286 20.2334C262.286 19.3402 262.437 18.5973 262.737 18.0049C263.043 17.4079 263.466 16.9613 264.009 16.665C264.551 16.3643 265.182 16.2139 265.902 16.2139ZM265.916 17.6973C265.51 17.6973 265.173 17.8271 264.904 18.0869C264.64 18.3467 264.487 18.7546 264.446 19.3105H267.372C267.368 19.0007 267.311 18.7249 267.201 18.4834C267.096 18.2419 266.937 18.0505 266.723 17.9092C266.513 17.7679 266.244 17.6973 265.916 17.6973ZM275.274 16.2139C276.136 16.2139 276.831 16.5488 277.359 17.2188C277.893 17.8887 278.159 18.8708 278.159 20.165C278.159 21.0309 278.034 21.7601 277.783 22.3525C277.533 22.9404 277.186 23.3848 276.744 23.6855C276.302 23.9863 275.794 24.1367 275.22 24.1367C274.851 24.1367 274.534 24.0911 274.27 24C274.005 23.9043 273.78 23.7835 273.593 23.6377C273.406 23.4873 273.244 23.3278 273.107 23.1592H272.998C273.035 23.3415 273.062 23.5283 273.08 23.7197C273.098 23.9111 273.107 24.098 273.107 24.2803V27.3633H271.022V16.3574H272.718L273.012 17.3486H273.107C273.244 17.1436 273.41 16.9544 273.606 16.7812C273.802 16.6081 274.037 16.4714 274.311 16.3711C274.589 16.2663 274.91 16.2139 275.274 16.2139ZM274.604 17.8818C274.24 17.8818 273.951 17.957 273.736 18.1074C273.522 18.2578 273.365 18.4834 273.265 18.7842C273.169 19.085 273.117 19.4655 273.107 19.9258V20.1514C273.107 20.6436 273.153 21.0605 273.244 21.4023C273.34 21.7441 273.497 22.0039 273.716 22.1816C273.939 22.3594 274.244 22.4482 274.632 22.4482C274.951 22.4482 275.213 22.3594 275.418 22.1816C275.623 22.0039 275.776 21.7441 275.876 21.4023C275.981 21.056 276.033 20.6344 276.033 20.1377C276.033 19.3903 275.917 18.8275 275.685 18.4492C275.452 18.071 275.092 17.8818 274.604 17.8818ZM281.967 24H279.882V13.3633H281.967V24ZM291.106 20.165C291.106 20.8031 291.02 21.3682 290.847 21.8604C290.678 22.3525 290.43 22.7695 290.102 23.1113C289.778 23.4486 289.386 23.7038 288.926 23.877C288.47 24.0501 287.955 24.1367 287.381 24.1367C286.843 24.1367 286.349 24.0501 285.897 23.877C285.451 23.7038 285.061 23.4486 284.729 23.1113C284.4 22.7695 284.145 22.3525 283.963 21.8604C283.785 21.3682 283.696 20.8031 283.696 20.165C283.696 19.3174 283.847 18.5996 284.147 18.0117C284.448 17.4238 284.877 16.9772 285.433 16.6719C285.989 16.3665 286.652 16.2139 287.422 16.2139C288.137 16.2139 288.771 16.3665 289.322 16.6719C289.878 16.9772 290.313 17.4238 290.628 18.0117C290.947 18.5996 291.106 19.3174 291.106 20.165ZM285.822 20.165C285.822 20.6663 285.877 21.0879 285.986 21.4297C286.096 21.7715 286.267 22.029 286.499 22.2021C286.731 22.3753 287.035 22.4619 287.408 22.4619C287.777 22.4619 288.076 22.3753 288.304 22.2021C288.536 22.029 288.705 21.7715 288.81 21.4297C288.919 21.0879 288.974 20.6663 288.974 20.165C288.974 19.6592 288.919 19.2399 288.81 18.9072C288.705 18.57 288.536 18.3171 288.304 18.1484C288.071 17.9798 287.768 17.8955 287.395 17.8955C286.843 17.8955 286.442 18.0846 286.191 18.4629C285.945 18.8411 285.822 19.4085 285.822 20.165ZM291.735 16.3574H294.019L295.461 20.6572C295.507 20.7939 295.545 20.9329 295.577 21.0742C295.609 21.2155 295.636 21.3613 295.659 21.5117C295.682 21.6621 295.7 21.8193 295.714 21.9834H295.755C295.782 21.7373 295.819 21.5072 295.864 21.293C295.914 21.0788 295.976 20.8669 296.049 20.6572L297.464 16.3574H299.699L296.466 24.9775C296.27 25.5062 296.015 25.946 295.7 26.2969C295.386 26.6523 295.023 26.9189 294.613 27.0967C294.208 27.2744 293.761 27.3633 293.273 27.3633C293.036 27.3633 292.831 27.3496 292.658 27.3223C292.485 27.2995 292.337 27.2744 292.214 27.2471V25.5928C292.31 25.6156 292.43 25.6361 292.576 25.6543C292.722 25.6725 292.875 25.6816 293.034 25.6816C293.326 25.6816 293.576 25.6201 293.786 25.4971C293.996 25.374 294.171 25.2077 294.312 24.998C294.454 24.793 294.565 24.5674 294.647 24.3213L294.771 23.9453L291.735 16.3574Z"
                fill="#7F7AD0"
              />
              <path
                d="M110.792 21.0213L106.379 25.7375C106.095 26.0594 105.533 26.0881 105.203 25.8079C104.874 25.5277 104.841 24.9933 105.146 24.6895L108.336 21.2833H95.8276C95.3705 21.2833 95 20.9313 95 20.4972C95 20.0631 95.3705 19.7112 95.8276 19.7112H108.336L105.146 16.305C104.841 16.0012 104.882 15.4677 105.212 15.1875C105.541 14.9074 106.095 14.9351 106.379 15.2569L110.792 19.9732C111.081 20.3545 111.058 20.6968 110.792 21.0213Z"
                fill="#7F7AD0"
              />
              <path
                d="M225.792 21.0213L221.379 25.7375C221.095 26.0594 220.533 26.0881 220.203 25.8079C219.874 25.5277 219.841 24.9933 220.146 24.6895L223.336 21.2833H210.828C210.371 21.2833 210 20.9313 210 20.4972C210 20.0631 210.371 19.7112 210.828 19.7112H223.336L220.146 16.305C219.841 16.0012 219.882 15.4677 220.212 15.1875C220.541 14.9074 221.095 14.9351 221.379 15.2569L225.792 19.9732C226.081 20.3545 226.058 20.6968 225.792 21.0213Z"
                fill="#7F7AD0"
              />
              <defs>
                <filter
                  id="filter0_d_186_290"
                  x="0"
                  y="0"
                  width="93"
                  height="43"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0901961 0 0 0 0 0.0392157 0 0 0 0 0.301961 0 0 0 0.15 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_186_290"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_186_290"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d_186_290"
                  x="114"
                  y="0"
                  width="93"
                  height="43"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0901961 0 0 0 0 0.0392157 0 0 0 0 0.301961 0 0 0 0.15 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_186_290"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_186_290"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter2_d_186_290"
                  x="229"
                  y="0"
                  width="93"
                  height="43"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0901961 0 0 0 0 0.0392157 0 0 0 0 0.301961 0 0 0 0.15 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_186_290"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_186_290"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <LinkButton
            demystIcon
            variant="secondary"
            onClick={sendCtaGaEvent}
            href={linksConstants.REQUEST_DEMO}
            data-test-id="home-hero-button"
            bookDemoButtonLandingPage={true}
          >
            Book demo
          </LinkButton>
          <Customers withMargin />
        </HeroCol>
      </Hero>
      <Section
        className={styles.BigNumbers}
        style={{ height: "500px" }}
        background="white"
        type="three-col"
      >
        <SectionCol>
          <SectionBigNumber
            svg={<SavedPerDeploymentSvg />}
            prefix="$"
            number="153"
            abbreviation="k"
            subtitle="Saved per deployment"
          />
        </SectionCol>
        <SectionCol>
          <SectionBigNumber
            svg={<LessCostSvg />}
            number="90"
            abbreviation="%"
            subtitle="Less time to success"
          />
        </SectionCol>
        <SectionCol>
          <SectionBigNumber
            svg={<ServingEnterprisesSvg />}
            number="14 "
            abbreviation="years"
            subtitle="Serving enterprises"
          />
        </SectionCol>
      </Section>
      <Section background="coolGray-50" type="two-col">
        <SectionCol>
          <SectionHeading type="h2">External data as a service</SectionHeading>
          <SectionParagraph type="subheading">
            Orchestrate and operationalize external data with speed, safety
            <br />
            and reliability like never before.
          </SectionParagraph>
          <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
            <LinkButton
              autoWidth
              href={"https://copilot.demyst.com/"}
              target="_blank"
              variant="inverted"
            >
              Discover Data (Beta)
            </LinkButton>
            <LinkButton autoWidth href={linksConstants.PLATFORM} variant="inverted">
              Operationalize Data; Platform Overview
            </LinkButton>
          </div>
        </SectionCol>
        <SectionCol>
          <SectionImage src={PlatformTop.src} alt="" width="702" height="431" layout="responsive" />
        </SectionCol>
      </Section>
      <Section
        type="two-col"
        removeBottomPadding
        removeTopPadding
        className={styles.ExternalDataDeployment}
        classSectionWrapper={styles.ClassSectionWrapper}
      >
        <SectionCol>
          <div className={styles.ExternalDataDeploymentMap}>
            <LocationMapHomePage />
          </div>
        </SectionCol>
        <SectionCol style={{ margin: 0, flexDirection: "column", alignItems: "center" }}>
          <div className={styles.ExternalDataDeploymentText}>
            <SectionHeading type="h2">Use cases: Powered by Demyst</SectionHeading>
            <SectionParagraph className={styles.ParagraphExternalDataDeployment} type="subheading">
              <div style={{ margin: 0, paddingRight: "1.0rem" }}>
                Demyst is your external data partner; handing the friction and delivering on high
                impact use cases.
                {/* Take a look at how Demyst is powering use cases today: * /}
              </div>
            </SectionParagraph>
            <LinkButton
              autoWidth
              href={linksConstants.POWERING}
              variant="inverted"
              style={{ margin: 0 }}
            >
              Case studies
            </LinkButton>
          </div>
        </SectionCol>
      </Section>

      <Section className={styles.ReadyToGetStart} background="blue-800" type="one-col">
        <SectionCol>
          <BottomCta />
        </SectionCol>
      </Section>

      <Section background="blue-1000" removeBottomPadding removeTopPadding>
        <SectionCol>
          <SecurityBadges />
        </SectionCol>
      </Section>
    </>
  );
  End of original HomePage content */ };

// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
;// CONCATENATED MODULE: ./pages/index.jsx




var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                displayCompanyName: false,
                title: meta/* meta.homepage.title */.$.homepage.title,
                description: meta/* meta.homepage.description */.$.homepage.description,
                currentPath: "/"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);